import { RESUMEQUEUE_TASK, RESUMEQUEUE_TASK_SUCCESSFUL, RESUMEQUEUE_TASK_FAILED } from './actionTypes';

export const resumeQueueTask = (task,token,history) => {
    return {
        type: RESUMEQUEUE_TASK,
        payload: { task,token, history }
    }
}

export const resumeQueueTaskSuccessful = (msg) => {
    return {
        type: RESUMEQUEUE_TASK_SUCCESSFUL,
        payload: msg
    }
}

export const resumeQueueTaskFailed = (msg) => {
    return {
        type: RESUMEQUEUE_TASK_FAILED,
        payload: msg
    }
}
